// extracted by mini-css-extract-plugin
export default {"link":"LegalDocuments_link__CTZhz","ul":"LegalDocuments_ul__LpMFt","li":"LegalDocuments_li__rKf+j","bold":"LegalDocuments_bold__b3zxc","italic":"LegalDocuments_italic__YQXkR"};